import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import InvoiceHeaderStyles from "./InvoiceHeaderStyles";
import { InvoiceDataType } from "../../api/invoice";
import { useBrandConfig } from "../../queries/shared";

const InvoiceHeader: React.FC<{
  data?: InvoiceDataType;
  title?: string;
}> = ({ data, title = "Tax Invoice" }) => {
  const styles = InvoiceHeaderStyles;
  const { data: brandConfig } = useBrandConfig();

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell sx={styles.logoCell} rowSpan={5} />
            <TableCell sx={styles.headerCell}>{title}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={styles.subHeaderCell}>
              {data?.seller_details?.name ?? data?.company?.name}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={styles.addressCell} data-testid="registered-address">
              <span style={{ fontWeight: 700, fontSize: "9px" }}>
                Registered Address:
              </span>{" "}
              {data?.seller_details?.registeredAddress ??
                data?.company?.registeredAddress}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={styles.factoryAddressCell}
              data-testid="factory-address"
            >
              <span style={{ fontWeight: 700, fontSize: "9px" }}>
                Factory Address:{" "}
              </span>
              {data?.company?.factoryAddress}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={styles.footerCell} colSpan={2}>
              <span style={{ fontWeight: 700, fontSize: "9px" }}>Tel:</span>{" "}
              {data?.seller_details?.phone ?? data?.company?.tel}
              <span style={{ fontWeight: 700, fontSize: "9px" }}>
                {" "}
                | Email:
              </span>{" "}
              {data?.seller_details?.email ?? data?.company?.email}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default InvoiceHeader;
